import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section id="hero" className="d-flex align-items-center">
            <div className="hero-overlay"></div>
            <div className="container position-relative z-index-1">
                <div className="hero-content">
                    <div className="hero-subtitle animate-slide-up animation-delay-1">
                        <span className="subtitle-line"></span> TOTAL HEALTH CARE SOLUTION
                    </div>
                    <h1 className="hero-title animate-slide-up animation-delay-2">
                        Your Most Trusted <br />
                        <span className="text-gradient">Health Partner</span>
                    </h1>
                    <p className="hero-desc animate-slide-up animation-delay-3">
                        Experience world-class healthcare with our expert professionals. We provide comprehensive medical services, seamless appointment booking, and personalized care for you and your family.
                    </p>
                    <div className="hero-actions d-flex justify-content-start gap-3 animate-slide-up animation-delay-4">
                        <Link to={'/doctors'} className="btn-get-started scrollto btn-glow">Get Started</Link>
                        <Link to={'/track-appointment'} className="btn-track scrollto">Track Appointment</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default HeroSection;